import type { ReactNode } from 'react';
import estilos from './Tarjeta.module.css';

interface Props {
  titulo?: string;
  children: ReactNode;
}

export function Tarjeta({ titulo, children }: Props) {
  return (
    <div className={estilos.tarjeta}>
      {titulo ? <h2 className={estilos.titulo}>{titulo}</h2> : null}
      {children}
    </div>
  );
}

/** Nota de lo que llegará en una fase posterior. Honesta, no un placeholder mudo. */
export function Pendiente({ children }: { children: ReactNode }) {
  return <p className={estilos.pendiente}>{children}</p>;
}

export function Suave({ children }: { children: ReactNode }) {
  return <p className={estilos.suave}>{children}</p>;
}
